// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as FlightsActiveActions } from '../duck';
import { actions as AlertActions } from '../../alert/duck';
import FlightsPast from '../components/FlightPast/FlightsPast';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    isFetchingPast: state.flights.isFetchingPast,
    pastFlights: state.flights.pastFlights,
    page: state.flights.pastFlightsPage,
    canAsk: state.flights.pastFlightsPageCanAsk,
    fetchPastError: state.flights.fetchPastError,
    locale: state.locale.locale,
    localValues: state.localValues,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...FlightsActiveActions, ...AlertActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FlightsPast);



// WEBPACK FOOTER //
// ./src/modules/flights/containers/FlightsPastContainer.js